import * as React from 'react';
import { Info } from 'lucide-react';
import { cn } from '../lib/utils';

// Short plain-language "what is this / what to do" banner for the top of a
// complex section. Keep the text to 1-3 short sentences.
export default function SectionIntro({ children, className }) {
  return (
    <div className={cn('flex gap-2.5 rounded-lg border border-border bg-muted/40 px-4 py-3 text-sm text-muted-foreground', className)}>
      <Info className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
      <div className="leading-snug">{children}</div>
    </div>
  );
}
